(() => {
  const MOBILE_MAX = 767;

  const isMobileProduct = () =>
    window.innerWidth <= MOBILE_MAX && document.body?.classList.contains('template-product');

  const hide = (element, reason) => {
    if (!element || element.dataset?.eeMobileCommerceGuard === 'hidden') return;
    if (element.dataset) {
      element.dataset.eeMobileCommerceGuard = 'hidden';
      element.dataset.eeMobileCommerceGuardReason = reason;
    }
    element.style.setProperty('display', 'none', 'important');
  };

  const hideShopifyInbox = () => {
    const selectors = [
      '#ShopifyChat',
      'shopify-chat',
      '[data-shopify-chat]',
      'iframe[src*="shopifychat" i]',
      'iframe[src*="shopify-chat" i]',
      'iframe[src*="shopifyinbox" i]',
      'iframe[src*="shopify-inbox" i]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach((element) => {
      hide(element, 'shopify-inbox');
    });
  };

  const fixedBottomHost = (element) => {
    let current = element;
    for (let depth = 0; current && depth < 6; depth += 1, current = current.parentElement) {
      const style = window.getComputedStyle(current);
      const rect = current.getBoundingClientRect();
      const isPinned = style.position === 'fixed' || style.position === 'sticky';
      const hugsBottom = rect.bottom >= window.innerHeight - 32 && rect.top < window.innerHeight;
      const bannerSized = rect.height > 20 && rect.height <= 190 && rect.width >= window.innerWidth * 0.45;

      if (isPinned && hugsBottom && bannerSized) return current;
    }
    return null;
  };

  const hideBottomKlaviyoBanner = () => {
    const candidates = document.querySelectorAll([
      '[class*="klaviyo" i]',
      '[id*="klaviyo" i]',
      'iframe[src*="klaviyo" i]'
    ].join(','));

    candidates.forEach((candidate) => {
      const host = fixedBottomHost(candidate);
      if (host) hide(host, 'bottom-klaviyo-banner');
    });
  };

  const apply = () => {
    if (!isMobileProduct()) return;
    hideShopifyInbox();
    hideBottomKlaviyoBanner();
  };

  let queued = false;
  const queueApply = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  window.addEventListener('resize', queueApply, { passive: true });
  new MutationObserver(queueApply).observe(document.documentElement, { childList: true, subtree: true });
})();
